<div class="container flex flex-col gap-2.5">
  <div class="m-0 flex flex-row items-center justify-end">
    <ion-button class="close" fill="clear" shape="round" (click)="dismiss()">
      <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
    </ion-button>
  </div>

  <div class="flex flex-col gap-10">
    <div class="flex flex-col items-center justify-center gap-5">
      <ion-icon *ngIf="deleteModal" class="alert-icon" src="../../../assets/icon/red-alert.svg"></ion-icon>
      <svg
        *ngIf="!deleteModal"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="17" fill="#43C0F6" />
        <circle cx="20" cy="20" r="18.5" stroke="#43C0F6" stroke-opacity="0.5" stroke-width="3" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.1906 12.4768C30.9056 15.4536 31.7768 19.001 30.7819 23.0222C29.8903 26.6213 27.7435 29.0666 24.4006 30.2884C20.7084 31.6393 17.0514 31.625 13.5318 29.0776C13.0746 28.7475 12.6372 28.3608 12.2142 27.9868L12.2047 27.9784C12.0082 27.8043 11.8051 27.6248 11.6012 27.4514C9.62086 25.4093 8.66053 22.6828 8.66608 20.3375C8.66287 19.3419 8.77386 18.3494 8.99702 17.3806C10.1652 12.4349 13.5194 9.4786 18.6163 8.69592C19.474 8.56458 22.6438 8.90143 23.2616 9.17883C24.7009 9.82325 26.5175 10.7493 27.9759 12.2489C28.0479 12.323 28.12 12.3999 28.1906 12.4768ZM14.726 28.64C17.8962 30.7135 21.1467 30.4692 24.3863 29.0847C25.6315 28.5443 26.7442 27.7257 27.6436 26.6882C28.5431 25.6507 29.2067 24.4204 29.5864 23.0865C30.3979 20.1975 30.0591 17.0372 28.549 14.8387C27.5861 13.4751 26.4024 12.2918 25.0496 11.3407C23.8257 10.5099 19.2255 8.91313 16.0178 10.4926C12.8625 11.9929 10.9373 14.1867 10.132 17.1966C9.8601 18.244 9.71752 19.3224 9.70714 20.4064C9.67585 22.9416 11.0921 25.4078 12.329 26.7565L12.3419 26.7713L12.3575 26.7831C12.4057 26.8213 12.5047 26.9021 12.6371 27.0102C13.1744 27.4487 14.2609 28.3355 14.726 28.64ZM19.5629 22.4172C19.572 22.4287 19.5833 22.4381 19.5963 22.4446C19.6092 22.4511 19.6234 22.4546 19.6378 22.4549C19.958 22.4485 20.1543 22.2936 20.2211 21.9948C20.2963 21.689 20.3515 21.3785 20.3867 21.0653C20.624 18.5835 20.7064 16.0885 20.6333 13.596C20.6217 13.2409 20.579 12.8305 20.3509 12.4772C20.2812 12.3871 20.1916 12.3154 20.0895 12.2681C20.0439 12.242 19.9968 12.2149 19.9517 12.184C19.9332 12.1713 19.9108 12.1659 19.8887 12.1692C19.8666 12.1722 19.8463 12.1836 19.8318 12.2008C19.793 12.2471 19.7519 12.2889 19.7113 12.3295C19.6207 12.4045 19.551 12.5027 19.5093 12.6144L19.4961 12.6636L19.4961 12.6638C19.404 13.0092 19.3087 13.3661 19.3053 13.7254C19.2845 15.8743 19.2795 18.0588 19.2747 20.173L19.2747 20.1737L19.2745 20.233L19.2711 21.6139C19.2615 21.7643 19.2777 21.9152 19.3189 22.0598C19.3614 22.1628 19.4221 22.2569 19.498 22.3371C19.5216 22.3649 19.5442 22.3915 19.5629 22.4172ZM18.8065 24.268C18.5237 24.8229 18.579 25.3989 18.9663 25.9347C19.3775 26.5032 19.9145 26.6377 20.5624 26.3344C20.5834 26.3246 20.5999 26.3069 20.6088 26.2851C20.6417 26.2038 20.6755 26.1239 20.709 26.0449C20.8954 25.6059 21.0709 25.1912 21.0175 24.7008C20.9571 24.1464 20.615 23.7398 20.1247 23.6397C20.0417 23.6227 19.9574 23.6141 19.8728 23.614C19.6537 23.6119 19.4383 23.6718 19.2502 23.7872C19.0621 23.9026 18.9086 24.0689 18.8065 24.268ZM19.9022 25.1748L19.9199 24.9072C19.9744 24.9561 20.0122 24.9967 20.0132 25.0198C20.0141 25.048 19.9708 25.1027 19.9022 25.1748Z"
          fill="white"
        />
      </svg>

      <h1 *ngIf="deleteModal" class="text-center">¡OJO! Vas a eliminar la carpeta "{{ folderName }}"</h1>
      <h1 *ngIf="warningCoupon">
        ¡OJO! Al superar los 35€ y obtener envío
        <ion-text color="success">GRATIS</ion-text>
        , ya no puedes hacer uso de tu cupón.
      </h1>
      <h1 *ngIf="bonusModal">
        ¡OJO! Al seleccionar tu bono monedero como método de pago, ya no puedes hacer uso de tu cupón.
      </h1>

      <h2 *ngIf="deleteModal">No podrás volver a recuperarla.</h2>
      <h2 *ngIf="warningCoupon">
        Pero tranquil&#64;, si luego escoges otro tipo de envío, podrás volver a aplicar tu cupón de descuento.
      </h2>
      <h2 *ngIf="bonusModal">
        Pero tranquil&#64;, si deseleccionas este método de pago, podrás volver a aplicar tu cupón de descuento.
      </h2>
    </div>

    <div class="flex w-full flex-row items-center justify-between gap-2.5">
      <ion-button fill="outline" color="dark" class="w-full" (click)="dismiss()"> Cancelar </ion-button>

      <ion-button
        *ngIf="deleteModal"
        class="delete-button flex w-full flex-row items-center justify-center gap-2.5"
        color="danger"
        (click)="close()"
      >
        <ion-icon src="../../../assets/icon/eliminar.svg"></ion-icon>
        <span>Eliminar ahora</span>
      </ion-button>

      <ion-button *ngIf="warningCoupon || bonusModal" class="confirm-button w-full" (click)="close()"
        >Aceptar
      </ion-button>
    </div>
  </div>
</div>
